module.exports = __webpack_public_path__ + "static/media/fixBottomRail.66223db6.png";